import React from 'react'
import styled from 'styled-components'
import { Room as RoomModel } from '../../../../../model/Event/Room'
import Door from './Door/Door'
import Floor from './Floor/Floor'

const Wrapper = styled.div`
  font-size: 2.5rem;
  color: #383838;
  margin: auto 0 0 0;
`

const Name = styled.div`
  min-width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  @media screen and (orientation: portrait) {
    max-height: 32rem;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
`

interface IProps {
  room: RoomModel
  roomName: string
}

const Room = ({ room, roomName }: IProps) => {
  const { route, floor, door } = room
  const showFloor = route && floor

  return (
    <Wrapper>
      {roomName && <Name>
        {roomName}
      </Name>}
      <div className="d-inline-flex">
        {showFloor && <Floor floor={floor}/>}
        {door && <Door doorNumber={door}/>}
      </div>
    </Wrapper>
  )
}

export default Room
